/**
 * Created by anatoly on 06.09.2024
 */

const DangerComponentView = cc.Node.extend({
    ctor: function (component) {
        this._super();

        const styles = cleverapps.styles.DangerComponentView;

        this.component = component;

        this.addTimer();
        this.addAnimation();

        this.setContentSize(styles);

        this.setAlignment(cleverapps.styles.DangerComponentView);

        component.on("onStop", this.stop.bind(this));
    },

    addAnimation: function () {
        const styles = cleverapps.styles.DangerComponentView.animation;

        const animation = this.animation = new cleverapps.Spine(bundles.danger_component.jsons.timer);

        animation.setAnimation(0, "animation");
        animation.setAlignment(styles);

        const animationDuration = animation.getAnimationDuration("animation");
        animation.setTimeScale(0);
        this.component.on("onStart", () => {
            const realDuration = this.component.getTimeLeft() / 1000;
            const timeScale = animationDuration / realDuration;
            animation.setTimeScale(timeScale);
        });

        this.addChild(animation);
    },

    addTimer: function () {
        const styles = cleverapps.styles.DangerComponentView.timer;

        const timerBg = cleverapps.UI.createScale9Sprite(bundles.danger_component.frames.timer_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);

        timerBg.setContentSize(styles.background);
        timerBg.setAlignment(styles);

        this.addChild(timerBg, -1);

        this.timerView = cleverapps.UI.generateImageText("00:00", cleverapps.styles.FONTS.DANGER_COMPONENT);
        this.updateTime();

        this.component.on("update", this.updateTime.bind(this));

        this.timerView.setAlignment(styles.text);

        this.addChild(this.timerView);
    },

    updateTime: function () {
        const timeLeft = this.component.getTimeLeft();
        this.timerView.setString(cleverapps.intervalToString(timeLeft, false));
    },

    stop: function () {
        this.animation.setTimeScale(0);
    }
});

cleverapps.styles.DangerComponentView = {
    width: 270,
    height: 100,

    x: { align: "left", dx: 20 },
    y: { align: "center", dy: 5 },

    timer: {
        x: { align: "center", dx: 70 },
        y: { align: "center", dy: -3 },

        background: {
            width: 210,
            height: 106
        },

        text: {
            x: { align: "center", dx: 90 },
            y: { align: "center" }
        }
    },

    animation: {
        x: { align: "left" },
        y: { align: "center" }
    }
};

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    DANGER_COMPONENT: {
        name: "nostroke",
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        size: 45
    }
});